"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("mktCourbesTauxChartConfigFactory", function ($numberFormat, chartUtils, $translate) {
  var _e = chartUtils.tooltipElement;
  return function getCourbesTauxChartConfig(options) {
    var height = options && options.height || 450;
    return {
      chart: {
        type: 'spline',
        height: height,
        borderColor: '#322f8f'
      },
      colors: ['#4DC100', '#005e75', '#F48600'],
      plotOptions: {
        series: {
          marker: {
            enabled: false
          }
        }
      },
      tooltip: {
        enabled: true,
        shared: true,
        formatter: function formatter() {
          var maturite = moment.duration(this.x, "years").humanize();
          var tooltip = _e("Maturité " + maturite + " : ", {
            bold: true,
            br: true
          });
          _.each(this.points, function (point) {
            var value = $numberFormat.percentage(point.y, 2);
            var serieLine = _e(point.series.name, {
              color: point.series.color,
              bold: true
            }) + _e(' : ' + value);
            tooltip += serieLine + "<br/>";
          });
          return tooltip;
        }
      },
      xAxis: {
        type: 'linear',
        allowDecimals: false,
        title: {
          text: $translate('marche.history.courbeTaux.graph.maturite')
        }
      },
      yAxis: {
        title: {
          text: $translate('marche.history.courbeTaux.graph.Taux')
        },
        labels: {
          formatter: function formatter() {
            return $numberFormat.percentage(this.value, 2);
          }
        },
        startOnTick: false
      }
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/courbes-taux/mktCourbesTauxChartConfigFactory.js
// module id = 2834
// module chunks = 13